import React from "react";
import {Box, Colors} from "@bounce/shared/ui";

const TOGGLE_HEIGHT = 36;
const TOGGLE_PADDING = 3;

type Option<T extends string> = {value: T; label: string};

type Props<T extends string> = {
  value: T;
  options: Option<T>[];
  onChange: (next: T) => void;
  ariaLabel: string;
};

export const SegmentedToggle = <T extends string>({value, options, onChange, ariaLabel}: Props<T>) => (
  <Box
    role="group"
    aria-label={ariaLabel}
    sx={{
      display: "inline-flex",
      backgroundColor: Colors.tertiary._200,
      borderRadius: "8px",
      height: TOGGLE_HEIGHT,
      p: `${TOGGLE_PADDING}px`,
      gap: `${TOGGLE_PADDING}px`,
    }}
  >
    {options.map((option) => {
      const selected = option.value === value;
      return (
        <Box
          key={option.value}
          component="button"
          type="button"
          aria-pressed={selected}
          onClick={() => onChange(option.value)}
          sx={{
            border: "none",
            px: 2,
            borderRadius: "6px",
            fontSize: 13,
            fontFamily: "inherit",
            fontWeight: selected ? 600 : 400,
            color: selected ? Colors.grey._900 : Colors.grey._600,
            backgroundColor: selected ? Colors.bw.white : "transparent",
            boxShadow: selected ? "0 1px 3px rgba(0,0,0,0.08)" : "none",
            cursor: "pointer",
          }}
        >
          {option.label}
        </Box>
      );
    })}
  </Box>
);
